import { CallProviderType } from '@gem/call/Model/callModel.types';
import { TAvatarBackgroundColorIndex } from '@gem/call/Removable/components/Avatar/Avatar';

import { IVideoQualitySettings } from '../Model/callModel.types';

export interface ICallConstructorParams {
  groupId?: string;
  channelId: string | null;
  providerType: CallProviderType;
  isUnauthorizedCall?: boolean;
  myId: string;
  initialDevicesIds: ICurrentMediaDeviceIds;
  mediaPermissions?: IMediaPermissions | null;
  maxParticipants: number;
  initialMeOpponentAvatar?: ICallAvatar;
}

export interface ICallLimits {
  maxParticipants: number;
  maxParticipantsReminder: number | null;
  maxDuration: number | null;
  maxDurationReminder: number | null;
  videoQualitySettings: IVideoQualitySettings | null;
}

export interface ICallAvatar {
  title: string | null;
  url: string | null;
  colorIndex: TAvatarBackgroundColorIndex | null;
}

export interface IDeviceInfo {
  deviceId: string;
  kind: MediaDeviceKind;
  label: string;
}

export interface IMediaDevices {
  audioinput: IDeviceInfo[];
  videoinput: IDeviceInfo[];
  audiooutput: IDeviceInfo[];
}

export interface ICurrentMediaDeviceIds {
  audioinput: string | null;
  videoinput: string | null;
  audiooutput: string | null;
}

export enum CallMediaPermissionValue {
  Initial = 'INITIAL',
  Accepted = 'ACCEPTED',
  Denied = 'Denied',
}

export interface IMediaPermissions {
  audio: CallMediaPermissionValue;
  video: CallMediaPermissionValue;
}
